import { Component, Input, OnInit, OnChanges, SimpleChanges, ElementRef, ViewChild } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { EssayAnswerResponse } from '../../../models/essay-pilot/essayAnswerResponse';
import { CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { PastEssaySubmissionResponse } from '../../../models/essay-pilot/pastEssaySubmissionResponse';
import { EssayPilotService } from '../../../services/essay-pilot/essay-pilot.service';
import { EssayCommentResponse } from '../../../models/essay-pilot/essayCommentResponse';
import { MessageService } from 'primeng/api';
import DOMPurify from 'dompurify';
@Component({
  selector: 'app-recent-submissions',
  standalone: true,
  imports: [ButtonModule, CommonModule],
  templateUrl: './recent-submissions.component.html',
  styleUrl: './recent-submissions.component.scss'
})
export class RecentSubmissionsComponent implements OnChanges {

  @ViewChild('targetText') targetText: ElementRef | undefined;
  activeCommentId: number | null = null;

  constructor(public sanitizer: DomSanitizer,
    private essayPilotService: EssayPilotService,
    private messageService: MessageService,
  ) {

  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['submissions'] && changes['submissions'].currentValue?.length > 0) {
      this.updateSelectedSubmission();
      this.listEssayComments();

    }
  }

  highlightComment(commentid: number){
    if(this.activeCommentId === commentid){
      this.activeCommentId = null;
    }else{
      this.activeCommentId = commentid;
    }
  }

  downloadEssay() {
    // Get the element containing the HTML answer
    const elementToPrint = document.getElementById('targetText');
    if (!elementToPrint) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Content not found to download.' });
      return;
    }

    // Prepare the question as H1 bold
    const question = this.selectedSubmission?.question
      ? `<h1 style='font-weight:bold;'>${this.escapeHtml(this.selectedSubmission.question)}</h1>`
      : '';

    // Prepare the HTML content for Word
    const htmlContent = `
      <html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'>
        <head><meta charset='utf-8'><title>Essay Answer</title></head>
        <body>${question}${this.sanitizeHtml(this.selectedSubmission?.htmlAnswer)}</body>
      </html>
    `;

    // Create a Blob with the correct MIME type
    const blob = new Blob([htmlContent], { type: 'application/msword' });
    const url = URL.createObjectURL(blob);

    // Create a temporary anchor to trigger download
    const a = document.createElement('a');
    const fileName = this.selectedSubmission?.question
      ? `${this.selectedSubmission.question.replace(/[^a-zA-Z0-9]/g, '_').substring(0, 40)}.doc`
      : 'essay-answer.doc';
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  private escapeHtml(text: string): string {
    return text.replace(/[&<>"']/g, function (c) {
      switch (c) {
        case '&': return '&amp;';
        case '<': return '&lt;';
        case '>': return '&gt;';
        case '"': return '&quot;';
        case "'": return '&#39;';
        default: return c;
      }
    });
  }

  private updateSelectedSubmission(): void {
    this.selectedSubmission = this.submissions.length > 0 ? this.submissions[this.submissions.length - 1] : null;
    this.listEssayComments();
  }

  @Input() submissions: PastEssaySubmissionResponse[] = [];

  selectedSubmission: PastEssaySubmissionResponse | null = null;
  commentList: EssayCommentResponse[] = [];

  listEssayComments(){
    this.essayPilotService.getEssayComments({
      pastEssaySubmissionId:this.selectedSubmission?.id,
      status: 1 //should show both pending(0) and resolved(1) comments
    }).subscribe({
      next:(response) =>{
        this.commentList = response.result;
      },
      error:(err) => {
        console.warn(`error while retriving essay comment list:${err}`)
      }
    })
  }


  // sanitizeHtml(html: string | null | undefined): string {
  //   return (html || '').replaceAll('&nbsp;', ' ');
  // }
  sanitizeHtml(html: string | null | undefined): string {
      if (!html) return '';

      let processedHtml = html.replaceAll('&nbsp;', ' ');
      const activeComment = this.commentList.find(c => c.id === this.activeCommentId);
      const text = activeComment?.selectedText.trim();

      if (text && text.length > 0) {
        // Escape special regex characters in the comment text
        const escapedText = text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        // Regex to match text outside of HTML tags
        const regex = new RegExp(`(?!<[^>]*?)(${escapedText})(?![^<]*?>)`, 'g');
        processedHtml = processedHtml.replace(
          regex,
          `<span class="highlight-comment">$1</span>`
        );
      }
      //Sanitize the final HTML output with DOMPurify
      const sanitized = DOMPurify.sanitize(processedHtml, {
        ALLOWED_TAGS: [
          'b', 'i', 'u', 'p', 'span', 'div', 'br', 'strong', 'em',
          'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
        ],
        ALLOWED_ATTR: ['style', 'class']
      });
      return sanitized;
    }

  openSubmission(response: PastEssaySubmissionResponse) {
    this.selectedSubmission = response;
    this.listEssayComments();

  }
}
